import { FC, ReactElement } from 'react';
import { Paper, Typography, useTheme, useMediaQuery } from '@mui/material';
import env from '../../config/env';
import { t } from 'i18next';

interface FooterProps {
  isDrawerOpen: boolean;
}

const Footer: FC<FooterProps> = ({ isDrawerOpen }): ReactElement => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: {
          xs: 0,
          sm: isDrawerOpen ? 240 : `calc(${theme.spacing(7)} + 1px)`,
        },
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 0.25,
        paddingX: 2,
        zIndex: 1100,
        transition: theme.transitions.create(['left'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(isMobile && { left: 0 }),
      }}
    >
      <Typography sx={{ fontSize: '0.7rem' }}>
        {t('VERSION')}: {env.VERSION}
      </Typography>

      <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold' }}>
        {t('POWERED_BY_ORDER_EZ')}
      </Typography>
    </Paper>
  );
};

export default Footer;
